import { render } from "./BaseRadioGroup.vue?vue&type=template&id=0890ff68&scoped=true"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=js"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=js"

import "./BaseRadioGroup.vue?vue&type=style&index=0&id=0890ff68&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0890ff68"]])

export default __exports__